import { models } from "types/api/viewModels.ts";
import { UserSettingsContainer } from "components/Preferences/UserSettings/userSettings.styles.ts";
import {
	AccountAdminsHeaderText,
	PriceFormatList,
	PriceFormatNet,
	PriceFormatNetWithMultiplier,
	ShowPricingUnavailableLabel,
	ViewSettingsText
} from "components/Preferences/text.ts";
import {
	AccountAdminsContainer,
	UserPermissionsInfoContainer
} from "components/Preferences/UserSettings/UserPermissionsInfo.styles.ts";
import { AcknowledgementPriceFormat } from "types/declarations/enums.ts";

export interface UserPermissionsInfoProps {
	userPermissions?: models["UserPermissionsViewModel"];
}

const UserPermissionsInfo = ({ userPermissions }: UserPermissionsInfoProps) => {
	const getAcknowledgementPermission = () => {
		switch (userPermissions?.acknowledgementPriceFormat) {
			case AcknowledgementPriceFormat.NET:
				return <li>{PriceFormatNet}</li>;
			case AcknowledgementPriceFormat.NET_MULTIPLIER:
				return <li>{PriceFormatNetWithMultiplier}</li>;
			case AcknowledgementPriceFormat.LIST:
				return <li>{PriceFormatList}</li>;
			default:
				return <li>{ShowPricingUnavailableLabel}</li>;
		}
	};

	return (
		<UserPermissionsInfoContainer>
			<AccountAdminsContainer>
				<div>{AccountAdminsHeaderText}</div>
				{userPermissions?.accountAdmins &&
					userPermissions.accountAdmins.length > 0 &&
					userPermissions?.accountAdmins.map((a) => {
						return (
							<div key={a.email}>
								{a.firstName} {a.lastName} ({a.email})
							</div>
						);
					})}
			</AccountAdminsContainer>
			<UserSettingsContainer>
				<div>{ViewSettingsText}</div>
				<ul>{getAcknowledgementPermission()}</ul>
			</UserSettingsContainer>
		</UserPermissionsInfoContainer>
	);
};

export default UserPermissionsInfo;
